import React from 'react'
import gql from 'graphql-tag'
import { Query } from 'react-apollo'
import { AttackEventNote } from '../../../../../graphql/schema/types/attack-event-note'
import { AttackEventNotesQueryArgs } from '../../../../../graphql/schema/types/attack-event-note-query-args'

export const ATTACK_EVENT_NOTES_QUERY_NAME = 'GetAttackEventNotes'

export const queryAttackEventNotes = gql`
  query GetAttackEventNotes($organizationId: ID!, $attackEventUuid: ID!) {
    attackEventNotes(
      organizationId: $organizationId
      attackEventUuid: $attackEventUuid
    ) {
      id
      uuid
      note
      creationTime
      lastModifiedTime
      createdByUserUuid
      createdByUserName
      createdByUserAvatarUrl
      lastUpdatedByUserName
    }
  }
`

interface Props {
  readonly organizationId: string
  readonly attackEventUuid: string
  readonly children: (attackEventNotes: AttackEventNote[]) => React.ReactNode
}

export function QueryAttackEventNotes(props: Props) {
  const { organizationId, attackEventUuid, children } = props
  return (
    <Query<{ attackEventNotes: AttackEventNote[] }, AttackEventNotesQueryArgs>
      query={queryAttackEventNotes}
      variables={{
        organizationId,
        attackEventUuid
      }}
    >
      {({ data, error, loading }) => {
        if (error || loading || !data) {
          return <div />
        }

        const { attackEventNotes } = data
        return children(attackEventNotes)
      }}
    </Query>
  )
}
